import { DocumentIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

const NoResultsIndicator = ({ message, description }) => {
  const { t } = useTranslation();
  const resolvedMessage = message || t("noResults.message");
  const resolvedDescription = description || t("noResults.description");

  return (
    // Empty state shown when no data or search results are available
    <div className="text-center py-4 px-4 text-gray-500 bg-white rounded-lg mt-1">
      <DocumentIcon className="w-16 h-16 mx-auto mb-4 text-gray-400" />
      <p className="text-lg font-medium">{resolvedMessage}</p>
      <p className="text-sm text-gray-400 mt-1">{resolvedDescription}</p>
    </div>
  );
};

export default NoResultsIndicator;
